<template>
  <div>
    <b-form-group>
      <b-modal
        ref="modalVehicle"
        id="modalVehicle"
        :title="isActivate ? $t('geral.deactivate') : $t('geral.activate')"
        :ok-title="$t('geral.save')"
        :cancel-title="$t('geral.cancel')"
        :hide-backdrop="cancelModal"
        @hidden="cancelModal"
      >
        <div v-if="!canAtivate">
          <label for="messageContact" class="alertMessage"
            >Sua franquia permite o cadastro de até
            {{ totalVehicles }} veículos. Para aumentar o limite, favor entrar
            em contato com nosso suporte.
          </label>
        </div>
        <div v-else>
          <b-col>
            <b-form-group
              :label="$t('controlVehicle.date')"
              label-for="controlVehicle.date"
            >
              <b-form-input type="date" v-model="model.datePerformed" />
              <span class="text-danger" v-if="modelstate['DatePerformed']">
                {{ "*" + modelstate["DatePerformed"][0] }}
              </span>
            </b-form-group>

            <b-form-group
              :label="$t('controlVehicle.reason')"
              label-for="controlVehicle.reason"
            >
              <vehicle-available-reason-dropdown
                :vehicleAvailable.sync="isActivate"
                :vehicleAvailableReasonId.sync="model.reasonId"
                :modelstate.sync="modelstate"
              />
            </b-form-group>

            <b-form-group
              :label="$t('controlVehicle.description')"
              label-for="controlVehicle.description"
            >
              <b-form-textarea v-model="model.availableDescription" />
              <span
                class="text-danger"
                v-if="modelstate['AvailableDescription']"
              >
                {{ "*" + modelstate["AvailableDescription"][0] }}
              </span>
            </b-form-group>
          </b-col>
        </div>

        <template #modal-footer="{}">
          <div style="text-align: right; width: 100%">
            <b-button
              v-if="!isActivate"
              variant="green"
              @click="activated"
              style="margin-left: 5px"
            >
              {{ $t("geral.confirm") }}
            </b-button>

            <b-button
              v-else-if="isActivate"
              variant="green"
              @click="deactivated"
              style="margin-left: 5px"
            >
              {{ $t("geral.confirm") }}
            </b-button>

            <b-button class="ml-2" variant="danger" @click="cancelModal">
              {{ $t("geral.cancel") }}
            </b-button>
          </div>
        </template>
        <!-- {{ model }} -->
      </b-modal>
    </b-form-group>
  </div>
</template>

<script>
export default {
  components: {
    "vehicle-available-reason-dropdown": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReasonDropDown.vue"
      ),
  },
  props: {
    vehicleId: Number,
    isActivate: Boolean,
    totalVehicleRegistered: Number,
    totalVehicles: Number,
  },
  data() {
    return {
      modelstate: {},
      options: [],
      data: null,
      model: {
        reasonId: null,
        datePerformed: null,
        availableDescription: null,
      },
    };
  },
  computed: {
    canAtivate() {
      if (this.isActivate) {
        return true;
      }
      if (this.totalVehicles == 0 || this.totalVehicleRegistered == 0) {
        return true;
      }
      if (
        this.totalVehicleRegistered <= this.totalVehicles &&
        !this.isActivate
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    vehicleId: {
      handler(newValue) {
        this.$emit("update:vehicleId", newValue);
      },
    },
  },
  mounted() {
    this.getCurrentDate();
  },
  methods: {
    getCurrentDate() {
      this.model.datePerformed = new Date().toISOString().split("T")[0];
    },
    deactivated() {
      this.modelstate = {};
      let obj = {
        vehicleId: this.vehicleId,
        reasonId: this.model.reasonId,
        datePerformed:
          this.model.datePerformed ?? new Date().toISOString().split("T")[0],
        availableDescription: this.model.availableDescription,
      };

      this.$apiVehicle
        .post("/vehicleAvailable/deactivate", obj)
        .then((response) => {
          console.log("Response: " + response);
          this.emptyFields();
          this.getCurrentDate();
          this.$refs.modalVehicle.hide();
          this.$emit("refreshTable");
        })
        .catch((error) => {
          console.log("Error: " + error);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          } else if (error.response.data.errorCode === 500) {
            this.modelstate = error.response.data.errorMessage;
          } else if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
    },
    activated() {
      this.modelstate = {};
      let obj = {
        vehicleId: this.vehicleId,
        reasonId: this.model.reasonId,
        datePerformed:
          this.model.datePerformed ?? new Date().toISOString().split("T")[0],
        availableDescription: this.model.availableDescription,
      };

      this.$apiVehicle
        .post("/vehicleAvailable/activate", obj)
        .then((response) => {
          console.log("Response: " + response);
          this.emptyFields();
          this.getCurrentDate();
          this.$refs.modalVehicle.hide();
          this.$emit("refreshTable");
        })
        .catch((error) => {
          console.log("Error: " + error);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          } else if (error.response.data.errorCode === 500) {
            this.modelstate = error.response.data.errorMessage;
            console.log(this.modelstate);
          } else if (error.response.status == 401) {
            this.emptyFields();
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.emptyFields();
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
    },
    emptyFields() {
      this.model = {
        datePerformed: null,
        reasonId: null,
        availableDescription: null,
      };
    },
    cancelModal() {
      this.modelstate = {};
      this.emptyFields();
      this.getCurrentDate();
      this.$refs.modalVehicle.hide();
    },
  },
};
</script>
<style scoped>
.alertMessage {
  color: #ffc600;
}
</style>